export default __webpack_public_path__ + "static/media/Img 021.fddec343.jpg";